<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Rejected Doctors",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Rejected Doctors",
            items: [
               {
                  text: "Rejected Doctors",
                  active: true,
               },                   
            ],

            listing_length: 10,
            keyword: '',

            from: null,
            to: null,
            total: null,
            pagination: {},

            doctors: [],
            token: '',
            errors: {},
            active_page_url: '',

            approve: {
               doctor_id: '',
               commision: '',
               convenience_fee: '',
            },
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchDoctors();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
         fetchDoctors(page_url = null) {

            this.getToken();
            let url = "api/admin/pending_doctors/reject_list?keyword=" + this.keyword + "&limit=" + this.listing_length;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.doctors = responseData.doctors.data;
                  
                  this.pagination = responseData.doctors.links;
                  this.from = responseData.doctors.from;
                  this.to = responseData.doctors.to;
                  this.total = responseData.doctors.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },        

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },   

         setApprove(doctor_id) {
            this.approve.doctor_id = doctor_id;
            this.showModal('approve-modal');
         },

         clearForm() {
            this.approve.doctor_id = '';
            this.approve.commision = '';
            this.approve.convenience_fee = '';

            this.errors = {};
         },

         approveDoctor() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let formData = new FormData();
            formData.append("id", this.approve.doctor_id); 
            formData.append("commision", this.approve.commision); 
            formData.append("convenience_fee", this.approve.convenience_fee); 
   
            let url = "api/admin/pending_doctors/approve";
            this.$axios
            .post(url, formData, config)
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.hideModal('approve-modal');
               this.fetchDoctors(this.active_page_url);
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                     this.$swal("", error.response.data.message, "error");
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
         },

         rejectDoctor(doctor_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to reject this doctor request?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };

                  let formData = new FormData();
                  formData.append("id", doctor_id); 
                       
                  let url = "api/admin/pending_doctors/reject";
                  this.$axios
                  .post(url, formData, config)
                  .then((response) => {
                     if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                     } else {
                        this.$swal("", response.data.message, "error");
                     }
                     this.fetchDoctors(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },

         deleteDoctor(doctor_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this Doctor?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                  console.log(this.token);
                  let formData = new FormData();
                  formData.append("doctor_id", doctor_id); 

                  // var formData = JSON.stringify({
                  //    "tv_show_id": tvshow_id
                  // });

                  let url = "api/admin/deleteRejectedDoctor";
                  this.$axios
                  .post(url, formData, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchDoctors(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">                

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length">
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword"/>
                           </label>
                        </div>                                      
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Name</th>  
                              <th>Contact</th>
                              <th>Specializations</th>  
                              <th>Created By</th>                              
                              <th>Created On</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(doctors.length)">
                           <tr v-for="(doctor) in doctors" :key="doctor.id">
                              <td><span v-if="doctor.prefix == 1">Dr.</span><span v-else-if="doctor.prefix == 2">Mr.</span><span v-else-if="doctor.prefix == 3">Ms.</span> {{doctor.name}}</td>                      
                              <td>
                                 +91 {{doctor.mobile}}<br>
                                 {{doctor.email}}<br>
                              </td>
                              <td>
                                 <span v-for="(specialization) in doctor.specializations" :key="specialization.id">
                                    {{specialization.specialization}}<br>
                                 </span>
                              </td>
                              <td>{{doctor.added_user_name}}</td>
                              <td>{{doctor.converted_created_at}}</td>
                              <td>
                                 <router-link :to="{ name: 'doctors.pending.details', params: {id: doctor.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Profile</router-link>

                                 <b-button variant="success" class="me-2 mb-2 btn-sm" @click="setApprove(doctor.id)">Approve</b-button>
                                 <button class="btn btn-danger btn-sm mb-2" type="button" @click="deleteDoctor(doctor.id)">Delete</button>

                              </td>
                           </tr>
                 
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No requests found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(doctors.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchDoctors(page.url + '&limit='+ listing_length + '&keyword=' + keyword)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends ---> 

               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <b-modal ref="approve-modal" id="approve-modal" title="Approve Doctor" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="approveDoctor()">
            <b-row>  

               <b-col lg="12" class="form-group">
                  <label class="control-label">Platform Fee<span class="text-danger">*</span></label>
                  <b-form-input type="number" min="0" v-model="approve.commision"></b-form-input>
                  
                  <div v-for="(val, index) in errors.commision" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col> 
               <b-col lg="12" class="form-group">
                  <label class="control-label">Convenience Fee<span class="text-danger">*</span></label>
                  <b-form-input type="number" min="0" v-model="approve.convenience_fee"></b-form-input>
                  
                  <div v-for="(val, index) in errors.convenience_fee" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>             
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Approve</b-button>
                  <b-button class="" variant="light" @click="hideModal('approve-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
